import { mdiMagnify, mdiOpenInNew } from '@mdi/js';

/** Same as helpers.DEFAULT_GROUP_COLOR — canvas icon accent. */
const BUTTON_GLYPH_COLOR = '#1971c2';

export const SIBLING_HOVER_BUTTON_R = 10;
/** MDI 24×24 glyphs, centered in the button. */
export const SIBLING_HOVER_MAGNIFY_PATH = mdiMagnify;
export const SIBLING_HOVER_OPEN_PATH = mdiOpenInNew;

/** Left-aligned to the icon card (x: 0), matching the well inset. */
export const SIBLING_HOVER_IDENTIFY_OFFSET = { x: 18, y: -16 };
export const SIBLING_HOVER_OPEN_OFFSET = { x: 42, y: -16 };

export function isSiblingMethodProp(prop) {
    return !!(prop && (prop.Type === 'FlowHeader' || prop.Type === 'APIHeader') && prop.ToolID);
}

export function siblingMethodDisplayName(prop) {
    return prop?.Model?.API?.Name || prop?.Model?.API?.Caption || 'method';
}

/** Inverse of paper zoom so the buttons stay ~20px on screen. */
export function siblingHoverButtonScale(paperScale) {
    const s = Number(paperScale);
    if (!s || s <= 0)
        return 1;
    return 1 / s;
}

export function siblingHoverButtonMarkup(iconPath, title) {
    return [
        {
            tagName: 'circle',
            selector: 'button',
            attributes: {
                r: SIBLING_HOVER_BUTTON_R,
                fill: '#ffffff',
                stroke: '#9aa8b5',
                'stroke-width': 1,
                cursor: 'pointer',
            },
        },
        {
            tagName: 'path',
            selector: 'icon',
            attributes: {
                d: iconPath,
                transform: 'scale(0.46) translate(-12, -12)',
                fill: BUTTON_GLYPH_COLOR,
                'pointer-events': 'none',
            },
        },
        {
            tagName: 'title',
            selector: 'tooltip',
            textContent: title,
        },
    ];
}

export function eventRelatedTarget(evt) {
    return evt?.relatedTarget || evt?.originalEvent?.relatedTarget || null;
}

export function isEventInsideJointTools(target) {
    return !!(target && typeof target.closest === 'function' && target.closest('.joint-tools'));
}
